import { render, staticRenderFns } from "./partner-page.vue?vue&type=template&id=787b8722&scoped=true"
import script from "./partner-page.vue?vue&type=script&lang=js"
export * from "./partner-page.vue?vue&type=script&lang=js"
import style0 from "./partner-page.vue?vue&type=style&index=0&id=787b8722&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "787b8722",
  null
  
)

export default component.exports